import { doc, updateDoc } from "firebase/firestore";
import { fireDB } from "./firebase";

// Share-login links: /ig-connect writes a doc holding the managed account's
// login token, the client opens /connect/{user_id} to auto-login and connect,
// and the agency's modal listens on the same doc and deletes it when done.
export const SHARE_LINK_COLLECTION = "connect_links";
export const SHARE_LINK_FLAG = "share_link_id";
export const SHARE_LINK_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function shareLinkDoc(id) {
  return doc(fireDB, SHARE_LINK_COLLECTION, id);
}

// Called from the connect success paths (fb-rdr and the FB page picker).
// The connect itself already succeeded, so a failed status write must never
// surface as an error to the client.
export async function markShareLinkConnected(username) {
  const id = localStorage.getItem(SHARE_LINK_FLAG);
  if (!id) return;
  localStorage.removeItem(SHARE_LINK_FLAG);
  try {
    await updateDoc(shareLinkDoc(id), {
      status: "connected",
      connected_username: username || null,
      connected_at: Date.now(),
    });
  } catch (err) {
    console.warn("share-link status update failed", err);
  }
}
